module.exports = __webpack_public_path__ + "static/kam-chauhan-social-media-113-e9044781700524c9c812481f66b50309.jpg";